import { installPolyfills } from '@sveltejs/kit/node/polyfills';

installPolyfills();
